import { NavLink } from "react-router-dom";
const menu = [
  { name: "Policies", path: "policies" },
  { name: "Annual Report", path: "annual-report" },
  { name: "Annual Return", path: "annual-return" },
  { name: "Share Holding Pattern", path: "shareholding-pattern" },
  { name: "Group Companies", path: "group-companies" },
  { name: "Investor Grievance", path: "investor-grievance-contact " },
  { name: "IPO", path: "ipo" },
  { name: "Industry Report", path: "industry-report" },
  { name: "Material Contracts & Document", path: "materialcontracts" },
  { name: "New & Old Name of Company", path: "name-change" },
];

const InvestorMenu = () => {
  return (
    <div className="investor-menu">
      {menu.map((item, i) => (
        <NavLink
          key={i}
          to={`/investor/${item.path}`}
          className={({ isActive }) =>
            isActive ? "menu-link active" : "menu-link"
          }
        >
          {item.name}
        </NavLink>
      ))}
    </div>
  );
};

export default InvestorMenu;
